import { createContext } from 'react';

export type ActiveRoleContextType = {
  /** The currently selected role (persisted to localStorage) */
  activeRole: string | null;
  /** All available roles for the current user */
  availableRoles: string[];
  /** Set the active role */
  setActiveRole: (role: string) => void;
  /** Whether role data is still loading */
  isLoading: boolean;
  /** Feature flags granted to the active role (snake_case names from DB) */
  roleFeatures: string[];
  /** Whether role features are currently being fetched */
  isLoadingFeatures: boolean;
  /**
   * True once `featuresForRole` has resolved (or been seeded from
   * `userInfo.assumedRoleFeatures`). Distinguishes "not fetched yet" from
   * "role has zero grants" — both otherwise present as `roleFeatures = []`.
   * Consumed by `useEffectiveFeatures` (#3942).
   */
  roleFeaturesResolved: boolean;
};

export const ActiveRoleContext = createContext<ActiveRoleContextType>({
  activeRole: null,
  availableRoles: [],
  setActiveRole: () => {
    console.error('ActiveRoleContext is missing a provider.');
  },
  isLoading: true,
  roleFeatures: [],
  isLoadingFeatures: false,
  roleFeaturesResolved: false,
});
